// extracted by mini-css-extract-plugin
module.exports = {"softcontentResult":"search-softcontent_softcontentResult__6LbDV"};